export const API_BASE_BASEPOINT: any = {
    ADDR_SUGG: 'address-suggestion',
    CATELOG_MGMT: 'catalogue-management',
    STORYBLOK: 'storyblok-management',
    CUSTOMER: 'customer-management',
  };